// src/components/SvgFilter.js
import React, { useEffect } from "react";

const SvgFilter = () => {
  useEffect(() => {
    const turbulence = document.querySelector("#turbulent-displace feTurbulence");
    let frame = 0;

    const animate = () => {
      frame += 0.01; // speed of ripple
      if (turbulence) {
        const freq = 0.03 + 0.01 * Math.sin(frame); // subtle oscillation
        turbulence.setAttribute("baseFrequency", freq.toString());
      }
      requestAnimationFrame(animate);
    };

    animate();
  }, []);

  return (
    <svg style={{ position: "absolute", width: 0, height: 0 }}>
      <defs>
        <filter id="turbulent-displace">
          <feTurbulence
            type="turbulence"
            baseFrequency="0.02"
            numOctaves="3"
            result="noise"
          />
          <feDisplacementMap
            in="SourceGraphic"
            in2="noise"
            scale="25"
            xChannelSelector="R"
            yChannelSelector="G"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default SvgFilter;
